export default __webpack_public_path__ + "static/slide-3-2fefcf33915b45cae150de83d8230b25.jpg";